import { render, staticRenderFns } from "./arviointipyynto-lahetetty.vue?vue&type=template&id=cc3112c0&scoped=true&"
import script from "./arviointipyynto-lahetetty.vue?vue&type=script&lang=ts&"
export * from "./arviointipyynto-lahetetty.vue?vue&type=script&lang=ts&"
import style0 from "./arviointipyynto-lahetetty.vue?vue&type=style&index=0&id=cc3112c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3112c0",
  null
  
)

export default component.exports